import { Component, OnInit, Inject, ViewChild, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormControl, UntypedFormControl } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatNavList } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { IconModule } from '../icon.module';
import { SelectionService } from '../../services/selection.service';
import { PSIC_COMPONENTS } from '@pacificspecialtyinsurancecompany/psic-ng-components';
import { LoadingComponent } from '../loading/loading.component';
import { ChatService } from 'src/app/shared/chat.service';
import { Router, ActivatedRoute } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth, UserClaims } from '@okta/okta-auth-js';
import { Store } from '@ngrx/store';
import { PolicyState } from 'src/app/store/policy/policy.reducer';
import * as PolicyActions from 'src/app/store/policy/policy.actions';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, take } from 'rxjs/operators';
import { setSelectedSection } from 'src/app/store/selection/selection.actions';
import { selectSelectedItem, selectSelectedSection } from 'src/app/store/selection/selection.selector';
import { getDocumentService } from 'src/app/services/get-documents.service';
import {
    MatAutocompleteModule,
    MatAutocompleteTrigger,
    MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { UserService } from 'src/app/services/user.service';
import { HighlightPipe } from '../pipes/highlight.pipe';
import { SECTION_SELECTOR_MAP } from '../global-messages';
import { addRecentPolicy } from 'src/app/store/recent-policies/recent-policies.actions';
import { selectRecentPolicies } from 'src/app/store/recent-policies/recent-policies.selector';
import { LetterOfExperienceService } from '../../services/data-service/letter-of-experience.service';
import { LoadingService } from 'src/app/shared/loading.service';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { ModalService } from 'src/app/shared/modal.service';
import { EmailService } from 'src/app/services/email.service';
import { PhoneService } from 'src/app/services/phone.service';
import { APP_CONFIG, AppConfig } from 'src/app.config';
import { CallIntentService } from 'src/app/services/call-intent.service';
import { PortletService } from 'src/app/services/portlet.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatIconModule,
        MatInputModule,
        MatSelectModule,
        IconModule,
        MatNavList,
        ...PSIC_COMPONENTS,
        LoadingComponent,
        MatAutocompleteModule,
        HighlightPipe,
    ],
})
export class HeaderComponent implements OnInit, OnDestroy {
    @Input() isThirdParty = false;
    @Output() profileNavToggled = new EventEmitter<Boolean>();
    policySearched: UntypedFormControl;
    typeSelected = '';
    formFocus = false;
    inputFocusFlag = false;
    showProfileNav = false;
    showNav = false;
    selectedTerm: string = '';
    selectedItem: string = '';
    policyNumber: string = '';
    showDropdownFlag = true;
    showRecentPoliciesFlag = true;
    entered: boolean;
    recentPolicies$: Observable<{ policyNumber: string; lineOfBusiness: string }[]>;
    lineOfBusiness: string = '';
    filteredDocs: Array<any> = [];
    userLoginName: string;
    user$: Observable<UserClaims>;
    userSubscription: Subscription;
    docSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private searchTooltipElement?: HTMLDivElement;
    @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
    policyLoaded = false;
    showActionsList: boolean = false;
    showPolicySnapActionsList: boolean = false;
    loading$: Observable<boolean>;
    policyData$: Observable<any>;
    termData$: Observable<any>;
    selectedTheme = 'psic';
    themeOptions = [
        { value: 'psic', label: 'PSIC Theme' },
        { value: 'red', label: 'Red Theme' },
        { value: 'green', label: 'Green Theme' },
        { value: 'neutral', label: 'Neutral Theme' },
        { value: 'blue', label: 'Blue Theme' },
    ];
    @Output() navToggled = new EventEmitter<boolean>();
    @Input() isLandingPage = false;
    sessionId: string | null = null;
    isProduction: boolean = false;
    snlLinkEnabled: boolean = false;
    @Output() themeChange = new EventEmitter<string>();
    defaultTheme: string = 'psic';
    themes: Array<{ value: string; label: string }> = [
        { value: 'psic', label: 'PSIC Theme' },
        { value: 'red', label: 'Red Theme' },
        { value: 'neutral', label: 'Neutral Theme' },
        { value: 'blue', label: 'Blue Theme' },
        { value: 'green', label: 'Green Theme' },
    ];

    allMenuItemList = [
        { image: 'user-circle', name: 'Insured profile' },
        { image: 'log-history', name: 'Latest activities' },
        { image: 'transfer', name: 'Transactions information' },
        { image: 'chat-round', name: 'Inbound / Outbound comms' },
        { image: 'documents', name: 'Recent documents' },
        { image: 'contact-me', name: 'Call intent' },
        { image: 'inspection', name: 'Inspections' },
        { image: 'ban', name: 'Moratorium activity' },
        { image: 'clipboard-notes', name: 'Notes' },
        { image: 'last-page', name: 'Quick actions' },
    ];
    allPolicyDetailList = [
        { image: 'document', name: 'Policy general information' },
        { image: 'payments', name: 'Payment information' },
        { image: 'bulk-commissions', name: 'Billing information' },
        { image: 'producer-management', name: 'Contact preferences' },
        { image: 'shield-check', name: 'Coverages' },
        { image: 'document-shield', name: 'Valuables' },
        { image: 'tabler-coin', name: 'Discounts & Surcharges' },
        { image: 'dollar-alt', name: 'Fees' },
        { image: 'download-2', name: 'Claims' },
        { image: 'last-page', name: 'Quick actions' },
    ];

    onThemeChange(event: Event) {
        const selectedTheme = (event.target as HTMLSelectElement).value;
        localStorage.setItem('selectedTheme', selectedTheme);
        this.themeChange.emit(selectedTheme);
    }

    get menuItemList() {
        return this.isThirdParty
            ? this.allMenuItemList.filter((item) => item.name === 'Insured profile' || item.name === 'Recent documents')
            : this.allMenuItemList;
    }

    get policyDetailList() {
        return this.isThirdParty
            ? this.allPolicyDetailList.filter(
                  (item) =>
                      item.name !== 'Quick actions' && item.name !== 'Claims' && item.name !== 'Contact preferences'
              )
            : this.allPolicyDetailList;
    }

    get isProfileActivitiesRoute(): boolean {
        return this.router.url.includes('profile-activities') && !this.router.url.includes('third-party');
    }

    constructor(
        public selectionService: SelectionService,
        private chatService: ChatService,
        private router: Router,
        private route: ActivatedRoute,
        public userService: UserService,
        private store: Store<{ policy: PolicyState }>,
        private docService: getDocumentService,
        private letterOfExperienceService: LetterOfExperienceService,
        @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
        @Inject(APP_CONFIG) private config: AppConfig,
        private loadingService: LoadingService,
        private toastService: ToastService,
        private modalService: ModalService,
        private emailService: EmailService,
        private phoneService: PhoneService,
        private callIntentService: CallIntentService,
        private portletService: PortletService
    ) {
        this.policySearched = new FormControl('');
        this.loading$ = this.store.select((state) => state.policy.loading);
        this.policyData$ = this.store.select((state) => state.policy.data);
        this.termData$ = this.store.select((state: any) => state.policy.termData);

        this.recentPolicies$ = this.store.select(selectRecentPolicies);
        this.isProduction = this.config.production;
        this.snlLinkEnabled = !!this.config.snlLinkEnabled;
        const storedTheme = localStorage.getItem('selectedTheme');
        if (storedTheme) {
            this.defaultTheme = storedTheme;
        }
    }
    private queryParamsSubscription: Subscription;
    private policyDataSubscription: Subscription;
    selectedItem$ = this.store.select(selectSelectedItem);
    selectedSection$ = this.store.select(selectSelectedSection);

    ngOnInit(): void {
        this.user$ = this.userService.user$;
        this.sessionId = this.route.snapshot.queryParamMap.get('sessionId');

        // Set initial nav state - collapsed by default
        if (!this.isLandingPage) {
            document.body.classList.add('nav-collapsed');
        }

        this.route.queryParams.pipe(take(1)).subscribe((params) => {
            const policyNumber = params['policyNumber'];
            if (policyNumber) {
                this.policySearched.setValue(policyNumber);
                // Load policy data for both CSR and third-party users
                this.store.dispatch(PolicyActions.loadPolicyData({ policyNumber }));
            }
        });

        if (this.router.url.startsWith('/call-intent')) {
            this.selectedItem = 'Call intent';
        }

        this.policyDataSubscription = this.policyData$.subscribe((data) => {
            if (data && !this.isThirdParty) {
                const policyKey =
                    Object.keys(data).find(
                        (k) => k.toLowerCase() === this.policySearched.value?.trim().toLowerCase()
                    ) || Object.keys(data)[Object.keys(data).length - 1]; // fallback to latest key

                // Restrict setting policyKey if it equals "TOKEN"
                if (policyKey?.toUpperCase() === 'TOKEN') {
                    console.warn('Policy key cannot be TOKEN. Skipping policy assignment.');
                    return;
                }

                this.policyNumber = policyKey;
                this.lineOfBusiness =
                    data[policyKey]?.policySnapshot?.policyGeneralInformation?.lineOfBusiness?.value || '';

                this.store.dispatch(addRecentPolicy({ policyNumber: policyKey, lineOfBusiness: this.lineOfBusiness }));

                this.chatService.clearMessages();
                this.policyLoaded = true;
                this.policySearched.setValue('');
            }
        });

        this.userSubscription = this.user$.subscribe((user: UserClaims) => {
            if (user && user.User_Name) {
                localStorage.setItem('user_name', user.User_Name);
                localStorage.setItem('producer_code', user.Producer_Code);
                this.userLoginName = user.name || '';
            }
            user.User_Name;
        });

        this.docSubject
            .pipe(
                filter((v) => !!v),
                distinctUntilChanged(),
                switchMap((value) =>
                    this.docService.getAllDocuments(value, this.isThirdParty, this.sessionId || undefined)
                )
            )
            .subscribe((data: any) => {
                if (Array.isArray(data)) {
                    this.filteredDocs = data;
                } else {
                    this.filteredDocs = [];
                }
            });
    }

    async logout(): Promise<void> {
        await this.oktaAuth.signOut();
        this.router.navigate(['/login']);
    }

    scrollToCard(sectionName: string) {
        const selector = SECTION_SELECTOR_MAP[sectionName];
        const el = selector ? (document.querySelector(selector) as HTMLElement) : document.getElementById(sectionName);
        if (el) {
            const container = el.closest('.profile-activities-container, .policy-snapshot-container') as HTMLElement;
            if (container) {
                const stickyEl = container.querySelector('app-policy-number') as HTMLElement;
                const stickyHeight = stickyEl ? stickyEl.offsetHeight : 0;
                const gap = 32; // psic-gap-8
                const top = el.offsetTop - container.offsetTop - stickyHeight + gap;
                container.scrollTo({ top, behavior: 'smooth' });
            }
        }
    }

    searchFocus() {
        if (window.innerWidth <= 767) {
            this.inputFocusFlag = true;
        }
        if (this.policyLoaded) {
            this.policySearched.setValue('');
            this.policyLoaded = false;
        }
    }

    blurOut() {
        this.formFocus = false;
    }

    searchPolicy(value: string, policyTerm?: string) {
        const trimmedValue = value?.trim();
        if (!trimmedValue) return;

        if (this.isThirdParty) {
            const sessionId = this.route.snapshot.queryParams['sessionId'];
            this.router.navigate(['/third-party-login'], {
                queryParams: { sessionId: sessionId, policyNumber: trimmedValue },
            });
            return;
        }
        if (this.filteredDocs.length === 0) {
            this.store.dispatch(PolicyActions.resetPolicyState());
            // this.selectionService.setIsLandingPage(true);
            this.policySearched.setValue('');
            this.router.navigate(['/profile-activities'], { replaceUrl: true });
            return;
        }

        this.termData$.pipe(take(1)).subscribe((termData) => {
            const term = policyTerm || this.selectedTerm || undefined;
            const matched = termData?.find((t: any) => t.term === term);
            const effectiveDate = matched?.startDate || undefined;

            this.store.dispatch(
                PolicyActions.loadPolicyData({
                    policyNumber: trimmedValue,
                    policyTerm: term,
                    effectiveDate,
                })
            );
        });

        const isCallIntent = this.router.url.startsWith('/call-intent');
        if (isCallIntent) {
            this.router.navigate(['/profile-activities'], {
                queryParams: { policyNumber: trimmedValue },
            });
        } else {
            this.router.navigate([], {
                relativeTo: this.route,
                queryParams: { policyNumber: trimmedValue },
                queryParamsHandling: 'merge',
            });
        }
    }

    mouseEnter(event: MouseEvent, index: number, tooltipText: string) {
        this.entered = true;
        (event.currentTarget as HTMLElement)?.classList.add('hovered');
        this.showSearchTooltip(event, tooltipText);
    }

    mouseLeave(event: MouseEvent, index: number) {
        this.entered = false;
        (event.currentTarget as HTMLElement)?.classList.remove('hovered');
        this.hideSearchTooltip();
    }

    private showSearchTooltip(event: MouseEvent, tooltipText: string) {
        if (!tooltipText?.trim()) {
            this.hideSearchTooltip();
            return;
        }

        if (!this.searchTooltipElement) {
            this.searchTooltipElement = document.createElement('div');
            this.searchTooltipElement.className = 'search-option-tooltip';
            document.body.appendChild(this.searchTooltipElement);
        }

        this.searchTooltipElement.textContent = tooltipText.trim();
        this.searchTooltipElement.style.visibility = 'hidden';
        this.searchTooltipElement.style.display = 'block';
        this.positionSearchTooltip(event);
        this.searchTooltipElement.style.visibility = 'visible';
    }

    positionSearchTooltip(event: MouseEvent) {
        if (!this.searchTooltipElement) {
            return;
        }

        const optionElement = (event.currentTarget as HTMLElement) || (event.target as HTMLElement);
        const rect = optionElement.getBoundingClientRect();
        const viewportPadding = 8;
        const sideGap = 8;
        const minSideWidth = 180;
        const availableRight = window.innerWidth - rect.right - sideGap - viewportPadding;
        const availableLeft = rect.left - sideGap - viewportPadding;
        // Default to left side; only fall back to right if left has insufficient space
        const shouldOpenRight = availableLeft < minSideWidth && availableRight >= minSideWidth;

        this.searchTooltipElement.style.maxWidth = `${Math.min(
            640,
            Math.max(minSideWidth, shouldOpenRight ? availableRight : availableLeft)
        )}px`;

        const tooltipRect = this.searchTooltipElement.getBoundingClientRect();
        let left = shouldOpenRight ? rect.right + sideGap : rect.left - tooltipRect.width - sideGap;
        let top = rect.top + (rect.height - tooltipRect.height) / 2;

        if (left + tooltipRect.width > window.innerWidth - viewportPadding) {
            left = window.innerWidth - tooltipRect.width - viewportPadding;
        }

        if (top + tooltipRect.height > window.innerHeight - viewportPadding) {
            top = window.innerHeight - tooltipRect.height - viewportPadding;
        }

        left = Math.max(viewportPadding, left);
        top = Math.max(viewportPadding, top);

        this.searchTooltipElement.style.left = `${left}px`;
        this.searchTooltipElement.style.top = `${top}px`;
    }

    hideSearchTooltip() {
        this.searchTooltipElement?.remove();
        this.searchTooltipElement = undefined;
    }

    getOptionValue(data: any, type: string, trim?: boolean) {
        let option: string = ' ';
        const policyNo = data.policyNo || data.PolicyNumber || '';
        const term = data.term || data.Term || '';
        const insured = data.FullName || data.fullName || '';
        const riskAddress = data.riskAddress || data.FullAddress || '';
        const lob = data.lob || data.LOB || '';

        switch (type) {
            case 'Policy number':
                option = ' ' + policyNo + ' - ' + term + ' - ' + riskAddress + ' - ' + lob;
                break;
            case 'Name insured':
                option = ' ' + insured + ' - ' + policyNo + ' - ' + term + ' - ' + riskAddress + ' - ' + lob;
                break;
            case 'Risk address':
                option = ' ' + riskAddress + ' - ' + policyNo + ' - ' + term + ' - ' + insured + ' - ' + lob;
                break;
            default:
                option = ' ' + policyNo + ' - ' + term + ' - ' + riskAddress + ' - ' + lob;
                break;
        }

        if (option.length > 60 && trim !== false) {
            option = option.substring(0, 45) + '...';
        }
        if (option.length <= 60 && trim === false) {
            option = '';
        }

        return option;
    }

    onIconClick() {
        if (this.policySearched.value) {
            this.policySearched.setValue('');
        } else {
            this.searchPolicy(this.policySearched.value || '');
        }
    }

    onPolicySelected(event: MatAutocompleteSelectedEvent) {
        this.hideSearchTooltip();
        this.scrollMainContentToTop();
        const selected = event.option.value;
        const policyNumber =
            selected?.policyNumber ||
            selected?.policyNo ||
            selected?.PolicyNumber ||
            selected?.policy_number ||
            selected;
        const policyTerm = selected?.term || selected?.Term || selected?.policyTerm || '';
        if (policyNumber) {
            this.selectedTerm = policyTerm;
            this.policySearched.setValue(policyNumber);
            this.searchPolicy(policyNumber, policyTerm);
            setTimeout(() => this.scrollMainContentToTop(), 0);
            setTimeout(() => this.scrollMainContentToTop(), 250);
        }
    }

    // selectRecentPolicy(policyNumber: string) {
    //     this.hideSearchTooltip();
    //     this.scrollMainContentToTop();
    //     this.searchPolicy(policyNumber);
    //     this.policySearched.setValue('');
    //     setTimeout(() => this.scrollMainContentToTop(), 0);
    //     setTimeout(() => this.scrollMainContentToTop(), 250);
    // }
    selectRecentPolicy(policyNumber: string) {
        this.hideSearchTooltip();
        this.scrollMainContentToTop();

        // Check LOB and policy number format before proceeding
        this.recentPolicies$.pipe(take(1)).subscribe((policies) => {
            const policy = policies.find((p) => p.policyNumber.toLowerCase() === policyNumber.toLowerCase());
            const lob = policy?.lineOfBusiness?.toUpperCase() || '';

            if (lob === 'MCST' || lob === 'MCOR') {
                this.toastService.add({
                    type: 'error',
                    title: 'Policy Not Supported',
                    message: `Policy ${policyNumber} cannot be searched for this line of business.`,
                });
                return;
            }

            if (/[^0-9]/.test(policyNumber.trim())) {
                this.toastService.add({
                    type: 'error',
                    title: 'Invalid Policy Number',
                    message: `Policy ${policyNumber} cannot be searched.`,
                });
                return;
            }

            // Clear selectedTerm so stale term data from the previously viewed policy
            // does not bleed into this new policy's loadPolicyData dispatch.
            // If selectedTerm is set and matches an entry in the old termData,
            // searchPolicy would include an effectiveDate for the wrong policy,
            // causing the fetchPolicyTerms$ gate (filter(!effectiveDate)) to skip
            // the phone search API entirely.
            this.selectedTerm = '';

            // Dispatch loadPolicyData directly without effectiveDate so the phone
            // search API is temp always called when switching via recent policies.
            // This bypasses the filteredDocs guard in searchPolicy (filteredDocs is
            // empty when the user has not typed in the search box) which would
            // otherwise reset state and navigate away without loading the policy.
            const trimmedPolicyNumber = policyNumber.trim();
            this.store.dispatch(PolicyActions.loadPolicyData({ policyNumber: trimmedPolicyNumber }));

            const isCallIntent = this.router.url.startsWith('/call-intent');
            if (isCallIntent) {
                this.router.navigate(['/profile-activities'], {
                    queryParams: { policyNumber: trimmedPolicyNumber },
                });
            } else {
                this.router.navigate([], {
                    relativeTo: this.route,
                    queryParams: { policyNumber: trimmedPolicyNumber },
                    queryParamsHandling: 'merge',
                });
            }

            this.policySearched.setValue('');
            setTimeout(() => this.scrollMainContentToTop(), 0);
            setTimeout(() => this.scrollMainContentToTop(), 250);
        });
    }

    private scrollMainContentToTop() {
        const scrollContainers = document.querySelectorAll<HTMLElement>(
            '.profile-activities-container, .policy-snapshot-container, .call-intent-container, .page-content, .landing-page'
        );

        scrollContainers.forEach((container) => {
            container.scrollTo({ top: 0, behavior: 'auto' });
        });

        window.scrollTo({ top: 0, behavior: 'auto' });
    }

    docChanged(value: string) {
        if (this.isThirdParty) return;
        this.docService.type.next(this.typeSelected);
        this.docSubject.next(value);
    }

    navigateToMenuItem(menuItem: string) {
        if (menuItem === 'Quick actions') {
            if (!this.showNav) this.toggleNav();
            this.showActions();
            return;
        }

        const currentPolicyNumber =
            this.policyNumber || this.router.parseUrl(this.router.url).queryParams['policyNumber'];

        if (menuItem === 'Call intent') {
            this.selectedItem = menuItem;
            this.router.navigate(['/call-intent'], {
                queryParams: { policyNumber: currentPolicyNumber },
                state: { customerIntent: this.callIntentService.lastCustomerIntent },
            });
            return;
        }
        this.selectedItem = menuItem;
        this.store.dispatch(setSelectedSection({ section: menuItem }));
        const route = this.isThirdParty ? '/profile-activities/third-party' : '/profile-activities';
        const queryParams = this.isThirdParty
            ? { sessionId: this.route.snapshot.queryParams['sessionId'] }
            : { policyNumber: currentPolicyNumber };
        this.router.navigate([route], { queryParams }).then(() => {
            this.router.navigate([route], { fragment: menuItem, queryParams }).then(() => {
                setTimeout(() => this.scrollToCard(menuItem), 100);
            });
        });
    }

    navigateToPolicyDetail(sectionName: string) {
        if (sectionName === 'Quick actions') {
            if (!this.showNav) this.toggleNav();
            this.showPolicySnapActions();
            return;
        }

        const currentPolicyNumber =
            this.policyNumber || this.router.parseUrl(this.router.url).queryParams['policyNumber'];

        this.selectedItem = sectionName;
        this.store.dispatch(setSelectedSection({ section: sectionName }));
        const route = this.isThirdParty ? '/profile-activities/third-party' : '/profile-activities';
        const queryParams = this.isThirdParty
            ? { sessionId: this.route.snapshot.queryParams['sessionId'] }
            : { policyNumber: currentPolicyNumber };
        this.router.navigate([route], { queryParams }).then(() => {
            this.router.navigate([route], { fragment: sectionName, queryParams }).then(() => {
                setTimeout(() => this.scrollToCard(sectionName), 100);
            });
        });
    }

    ngOnDestroy(): void {
        this.hideSearchTooltip();
        this.userSubscription.unsubscribe();
        if (this.queryParamsSubscription) {
            this.queryParamsSubscription.unsubscribe();
        }
        if (this.policyDataSubscription) {
            this.policyDataSubscription.unsubscribe();
        }
    }

    //landing-page-header
    isRotated = false;
    chatHistory = [
        { label: 'Recent conversations', chatDescriptions: [], isRotated: false },
        { label: 'Last 7 days', chatDescriptions: [], isRotated: false },
        { label: 'Last 30 days', chatDescriptions: [], isRotated: false },
    ];

    toggleRotation(index: number) {
        this.chatHistory[index].isRotated = !this.chatHistory[index].isRotated;
    }

    toggleNav() {
        this.showNav = !this.showNav;
        this.showProfileNav = false;
        if (this.showNav) {
            document.body.classList.add('nav-open');
            document.body.classList.remove('nav-collapsed');
        } else {
            document.body.classList.remove('nav-open');
            document.body.classList.add('nav-collapsed');
        }
        this.navToggled.emit(this.showNav);
    }

    openRecentPolicies() {
        this.toggleNav();
        this.showRecentPoliciesFlag = true;
    }

    showActions() {
        this.showActionsList = !this.showActionsList;
    }

    showPolicySnapActions() {
        this.showPolicySnapActionsList = !this.showPolicySnapActionsList;
    }

    isLetterLoading = false;

    generateLetterOfExperience() {
        if (!this.policyNumber) return;

        const confirmationPopup = {
            type: 'actionDialog',
            imageSrc: '../../../../assets/images/exclamation-triangle-line.svg',
            message: "You're about to<br>generate a LoE",
            messageExt: 'The Letter of Experience will be<br>stored in Document Hub.',
            cancel: 'Cancel',
            confirm: 'Confirm',
            fields: [],
        };

        const confirmSubscription = this.modalService
            .confirm(confirmationPopup, 'loe-dialog-modal')
            .subscribe((response) => {
                if (response && response.includes('Confirm')) {
                    this.proceedWithLOEGeneration();
                }
            });
    }

    private proceedWithLOEGeneration() {
        this.loadingService.showLoading();
        this.letterOfExperienceService.generate(this.policyNumber).subscribe({
            next: (response: any) => {
                this.loadingService.hideLoading();
                this.toastService.add({
                    type: 'success',
                    title: 'Success',
                    message:
                        'The LoE will be available in Recent Documents shortly. Reload the section in a few minutes to view the file.',
                });
            },
            error: (error: any) => {
                this.loadingService.hideLoading();
                this.toastService.add({
                    type: 'error',
                    title: 'Error',
                    message: error.error?.message || 'Failed to generate Letter of Experience. Please try again.',
                });
            },
        });
    }

    sendPaymentLinkSMS() {
        if (!this.policyNumber) {
            this.toastService.add({
                type: 'error',
                title: 'Error',
                message: 'No policy selected',
            });
            return;
        }

        this.policyData$.pipe(take(1)).subscribe((data) => {
            const insuredInformation =
                data?.[this.policyNumber]?.policySnapshot?.contactPreferences?.insuredInformation;

            const popup = {
                type: 'actionDialog',
                emailVerified: false,
                messageTitle: 'Send Payment Link',
                messageSubtitle: 'Select the channel through which the payment link will be sent.',
                imageSrc: 'assets/images/send-document.svg',
                imageWidth: '120px',
                imageHeight: '120px',
                confirm: 'Send',
                cancel: 'Cancel',
                validationServices: {
                    emailService: this.emailService,
                    phoneService: this.phoneService,
                },
                fields: [
                    {
                        name: 'sendVia',
                        value: 'email',
                        caption: '',
                        type: 'radio',
                        required: true,
                        description: '',
                        options: {
                            optionsList: [
                                {
                                    name: 'sendVia',
                                    value: 'email',
                                    caption: '',
                                    description: 'Send via Email',
                                    type: 'radio',
                                    required: false,
                                    id: 'email',
                                },
                                {
                                    name: 'sendVia',
                                    value: 'sms',
                                    caption: '',
                                    description: 'Send via SMS',
                                    type: 'radio',
                                    required: false,
                                    id: 'sms',
                                },
                            ],
                        },
                    },
                    {
                        type: 'text',
                        caption: 'Email',
                        name: 'email',
                        id: 'email',
                        placeholder: 'Enter email address',
                        required: true,
                        keyboardFilter: 'email',
                        value: '',
                        validationMessages: [
                            {
                                type: 'emailService',
                                message: 'This email address is invalid. Please check and try again.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Email',
                        name: 'verifyEmail',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'text',
                        caption: 'Mobile Number',
                        name: 'mobileNumber',
                        id: 'mobileNumber',
                        placeholder: 'Enter mobile number',
                        required: true,
                        value: '',
                        keyboardFilter: 'pint',
                        maxLength: 10,
                        validationMessages: [
                            {
                                type: 'phoneService',
                                message: 'This phone number is invalid. Please double-check it.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Phone',
                        name: 'verifyPhone',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                ],
            };

            this.modalService.confirm(popup, undefined, insuredInformation).subscribe({
                next: (popupCallbackDetail: any) => {
                    if (popupCallbackDetail?.[0] === 'Send') {
                        const formData = popupCallbackDetail[1];

                        if (typeof formData === 'object' && formData.sendVia) {
                            if (formData.sendVia === 'email') {
                                this.policyData$.pipe(take(1)).subscribe((data) => {
                                    if (data && data[this.policyNumber]) {
                                        const policySnapshot = data[this.policyNumber].policySnapshot;
                                        const address =
                                            policySnapshot?.policyGeneralInformation?.propertyFullAddress?.value || '';
                                        const zipcode = this.extractZipcode(address);
                                        this.sendPaymentLinkByEmail(formData.email, zipcode);
                                    }
                                });
                            } else if (formData.sendVia === 'sms') {
                                this.policyData$.pipe(take(1)).subscribe((data) => {
                                    if (data && data[this.policyNumber]) {
                                        const policySnapshot = data[this.policyNumber].policySnapshot;
                                        const address =
                                            policySnapshot?.policyGeneralInformation?.propertyFullAddress?.value || '';
                                        const paymentLink = this.config.smsPaymentLink;
                                        const zipcode = this.extractZipcode(address);

                                        this.phoneService
                                            .sendPaymentLinkSMS(
                                                formData.mobileNumber,
                                                this.policyNumber,
                                                paymentLink,
                                                zipcode
                                            )
                                            .subscribe({
                                                next: (response) => {
                                                    this.toastService.add({
                                                        type: 'success',
                                                        title: 'Success',
                                                        message: 'The payment link was sent successfully',
                                                    });
                                                },
                                                error: (error) => {
                                                    console.error('SMS Error:', error);
                                                    this.toastService.add({
                                                        type: 'error',
                                                        title: 'Error',
                                                        message: "The payment link couldn't be sent",
                                                    });
                                                },
                                            });
                                    }
                                });
                            }
                        }
                    }
                },
                error: () =>
                    this.toastService.add({
                        type: 'error',
                        title: 'Error',
                        message: 'Unable to open dialog. Please try again.',
                    }),
            });
        });
    }

    private sendPaymentLinkByEmail(email: string, zipcode: string): void {
        if (!this.emailService.validateEmailFormat(email)) {
            this.toastService.add({
                type: 'error',
                title: 'Invalid Email',
                message: 'Please enter a valid email address.',
            });
            return;
        }

        const emailRequest = this.emailService.buildPaymentLinkEmailRequest(
            email,
            this.policyNumber,
            this.config.smsPaymentLink,
            zipcode
        );

        this.emailService.sendDocumentEmail(emailRequest as any).subscribe({
            next: () =>
                this.toastService.add({
                    type: 'success',
                    title: 'Success',
                    message: 'The payment link was sent successfully via email.',
                }),
            error: () =>
                this.toastService.add({
                    type: 'error',
                    title: 'Error',
                    message: "The payment link couldn't be sent.",
                }),
        });
    }

    sendThirdPartyLink() {
        this.policyData$.pipe(take(1)).subscribe((data) => {
            const popup = {
                type: 'actionDialog',
                emailVerified: false,
                messageTitle: 'Share Third Party Link',
                messageSubtitle: 'Select the channel through which the link will be sent.',
                imageSrc: 'assets/images/send-document.svg',
                imageWidth: '120px',
                imageHeight: '120px',
                confirm: 'Send',
                cancel: 'Cancel',
                validationServices: {
                    emailService: this.emailService,
                    phoneService: this.phoneService,
                },
                fields: [
                    {
                        name: 'sendVia',
                        value: 'email',
                        caption: '',
                        type: 'radio',
                        required: true,
                        description: '',
                        options: {
                            optionsList: [
                                {
                                    name: 'sendVia',
                                    value: 'email',
                                    caption: '',
                                    description: 'Send via Email',
                                    type: 'radio',
                                    required: false,
                                    id: 'email',
                                },
                                {
                                    name: 'sendVia',
                                    value: 'sms',
                                    caption: '',
                                    description: 'Send via SMS',
                                    type: 'radio',
                                    required: false,
                                    id: 'sms',
                                },
                            ],
                        },
                    },
                    {
                        type: 'text',
                        caption: 'Email',
                        name: 'email',
                        id: 'email',
                        placeholder: 'Enter email address',
                        required: true,
                        keyboardFilter: 'email',
                        value: '',
                        validationMessages: [
                            {
                                type: 'emailService',
                                message: 'This email address is invalid. Please check and try again.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Email',
                        name: 'verifyEmail',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'text',
                        caption: 'Mobile Number',
                        name: 'mobileNumber',
                        id: 'mobileNumber',
                        placeholder: 'Enter mobile number',
                        required: true,
                        value: '',
                        keyboardFilter: 'pint',
                        maxLength: 10,
                        validationMessages: [
                            {
                                type: 'phoneService',
                                message: 'This phone number is invalid. Please double-check it.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Phone',
                        name: 'verifyPhone',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                ],
            };

            this.modalService.confirm(popup, undefined).subscribe({
                next: (popupCallbackDetail: any) => {
                    if (popupCallbackDetail?.[0] === 'Send') {
                        const formData = popupCallbackDetail[1];

                        if (typeof formData === 'object' && formData.sendVia) {
                            if (formData.sendVia === 'email') {
                                this.sendThirdPartyLinkByEmail(formData.email);
                            } else if (formData.sendVia === 'sms') {
                                this.phoneService
                                    .sendThirdPartyLinkSMS(formData.mobileNumber, this.config.thirdPartyLoginURL)
                                    .subscribe({
                                        next: (response) => {
                                            this.toastService.add({
                                                type: 'success',
                                                title: '',
                                                message: 'The third party link was sent successfully.',
                                            });
                                        },
                                        error: (error) => {
                                            console.error('SMS Error:', error);
                                            this.toastService.add({
                                                type: 'error',
                                                title: '',
                                                message: "The third party link couldn't be sent.",
                                            });
                                        },
                                    });
                            }
                        }
                    }
                },
                error: () =>
                    this.toastService.add({
                        type: 'error',
                        title: 'Error',
                        message: 'Unable to open dialog. Please try again.',
                    }),
            });
        });
    }

    private sendThirdPartyLinkByEmail(email: string): void {
        if (!this.emailService.validateEmailFormat(email)) {
            this.toastService.add({
                type: 'error',
                title: 'Invalid Email',
                message: 'Please enter a valid email address.',
            });
            return;
        }

        const emailRequest = this.emailService.buildThirdPartyLinkEmailRequest(
            email,
            this.policyNumber,
            this.config.thirdPartyLoginURL
        );

        this.emailService.sendDocumentEmail(emailRequest as any).subscribe({
            next: () =>
                this.toastService.add({
                    type: 'success',
                    title: '',
                    message: 'The third party link was sent successfully via email.',
                }),
            error: () =>
                this.toastService.add({
                    type: 'error',
                    title: '',
                    message: "The third party link couldn't be sent.",
                }),
        });
    }

    private extractZipcode(address: string): string {
        const zipcodeMatch = address.match(/\b(\d{5}(-\d{4})?)\b/);
        return zipcodeMatch ? zipcodeMatch[1] : '';
    }

    sendPortletLink() {
        if (!this.policyNumber) {
            this.toastService.add({
                type: 'error',
                title: 'Error',
                message: 'No policy selected',
            });
            return;
        }

        this.policyData$.pipe(take(1)).subscribe((data) => {
            const insuredInformation =
                data?.[this.policyNumber]?.policySnapshot?.contactPreferences?.insuredInformation;

            const popup = {
                type: 'actionDialog',
                emailVerified: false,
                messageTitle: 'Send Portlet Link',
                messageSubtitle: 'Select the channel through which the portlet link will be sent.',
                imageSrc: 'assets/images/send-document.svg',
                imageWidth: '120px',
                imageHeight: '120px',
                confirm: 'Send',
                cancel: 'Cancel',
                validationServices: {
                    emailService: this.emailService,
                    phoneService: this.phoneService,
                },
                fields: [
                    {
                        name: 'sendVia',
                        value: 'email',
                        caption: '',
                        type: 'radio',
                        required: true,
                        description: '',
                        options: {
                            optionsList: [
                                {
                                    name: 'sendVia',
                                    value: 'email',
                                    caption: '',
                                    description: 'Send via Email',
                                    type: 'radio',
                                    required: false,
                                    id: 'email',
                                },
                                {
                                    name: 'sendVia',
                                    value: 'sms',
                                    caption: '',
                                    description: 'Send via SMS',
                                    type: 'radio',
                                    required: false,
                                    id: 'sms',
                                },
                            ],
                        },
                    },
                    {
                        type: 'text',
                        caption: 'Email',
                        name: 'email',
                        id: 'email',
                        placeholder: 'Enter email address',
                        required: true,
                        keyboardFilter: 'email',
                        value: '',
                        validationMessages: [
                            {
                                type: 'emailService',
                                message: 'This email address is invalid. Please check and try again.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Email',
                        name: 'verifyEmail',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'text',
                        caption: 'Mobile Number',
                        name: 'mobileNumber',
                        id: 'mobileNumber',
                        placeholder: 'Enter mobile number',
                        required: true,
                        value: '',
                        keyboardFilter: 'pint',
                        maxLength: 10,
                        validationMessages: [
                            {
                                type: 'phoneService',
                                message: 'This phone number is invalid. Please double-check it.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Phone',
                        name: 'verifyPhone',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                ],
            };

            this.modalService.confirm(popup, undefined, insuredInformation).subscribe({
                next: (popupCallbackDetail: any) => {
                    if (popupCallbackDetail?.[0] === 'Send') {
                        const formData = popupCallbackDetail[1];

                        if (typeof formData === 'object' && formData.sendVia) {
                            this.policyData$.pipe(take(1)).subscribe((policyData) => {
                                if (!policyData || !policyData[this.policyNumber]) {
                                    this.toastService.add({
                                        type: 'error',
                                        title: 'Error',
                                        message: 'Policy data is not available.',
                                    });
                                    return;
                                }

                                const policySnapshot = policyData[this.policyNumber].policySnapshot;
                                const address =
                                    policySnapshot?.policyGeneralInformation?.propertyFullAddress?.value || '';
                                const zipcode = this.extractZipcode(address);

                                this.loadingService.showLoading();
                                this.portletService
                                    .getPortletLink({
                                        policyNumber: this.policyNumber,
                                        propertyZipCode: zipcode,
                                    })
                                    .subscribe({
                                        next: (portletLink) => {
                                            this.loadingService.hideLoading();
                                            if (formData.sendVia === 'email') {
                                                this.sendPortletLinkByEmail(formData.email, portletLink);
                                            } else if (formData.sendVia === 'sms') {
                                                this.phoneService
                                                    .sendPortletLinkSMS(
                                                        formData.mobileNumber,
                                                        this.policyNumber,
                                                        portletLink
                                                    )
                                                    .subscribe({
                                                        next: () => {
                                                            this.toastService.add({
                                                                type: 'success',
                                                                title: 'Success',
                                                                message: 'The portlet link was sent successfully',
                                                            });
                                                        },
                                                        error: (error) => {
                                                            console.error('SMS Error:', error);
                                                            this.toastService.add({
                                                                type: 'error',
                                                                title: 'Error',
                                                                message: "The portlet link couldn't be sent",
                                                            });
                                                        },
                                                    });
                                            }
                                        },
                                        error: (error) => {
                                            this.loadingService.hideLoading();
                                            console.error('Portlet session error:', error);
                                            this.toastService.add({
                                                type: 'error',
                                                title: 'Error',
                                                message: 'Unable to generate portlet link. Please try again.',
                                            });
                                        },
                                    });
                            });
                        }
                    }
                },
                error: () =>
                    this.toastService.add({
                        type: 'error',
                        title: 'Error',
                        message: 'Unable to open dialog. Please try again.',
                    }),
            });
        });
    }

    private sendPortletLinkByEmail(email: string, portletLink: string): void {
        if (!this.emailService.validateEmailFormat(email)) {
            this.toastService.add({
                type: 'error',
                title: 'Invalid Email',
                message: 'Please enter a valid email address.',
            });
            return;
        }

        const emailRequest = this.emailService.buildPortletLinkEmailRequest(email, this.policyNumber, portletLink);

        this.emailService.sendDocumentEmail(emailRequest as any).subscribe({
            next: () =>
                this.toastService.add({
                    type: 'success',
                    title: 'Success',
                    message: 'The portlet link was sent successfully via email.',
                }),
            error: () =>
                this.toastService.add({
                    type: 'error',
                    title: 'Error',
                    message: "The portlet link couldn't be sent.",
                }),
        });
    }

    sendDocumentUploadLink() {
        if (!this.policyNumber) {
            this.toastService.add({
                type: 'error',
                title: 'Error',
                message: 'No policy selected',
            });
            return;
        }

        this.policyData$.pipe(take(1)).subscribe((data) => {
            const insuredInformation =
                data?.[this.policyNumber]?.policySnapshot?.contactPreferences?.insuredInformation;

            const popup = {
                type: 'actionDialog',
                emailVerified: false,
                messageTitle: 'Send Document Upload Link',
                messageSubtitle: 'Select the channel through which the document upload link will be sent.',
                imageSrc: 'assets/images/send-document.svg',
                imageWidth: '120px',
                imageHeight: '120px',
                confirm: 'Send',
                cancel: 'Cancel',
                validationServices: {
                    emailService: this.emailService,
                    phoneService: this.phoneService,
                },
                fields: [
                    {
                        name: 'sendVia',
                        value: 'email',
                        caption: '',
                        type: 'radio',
                        required: true,
                        description: '',
                        options: {
                            optionsList: [
                                {
                                    name: 'sendVia',
                                    value: 'email',
                                    caption: '',
                                    description: 'Send via Email',
                                    type: 'radio',
                                    required: false,
                                    id: 'email',
                                },
                                {
                                    name: 'sendVia',
                                    value: 'sms',
                                    caption: '',
                                    description: 'Send via SMS',
                                    type: 'radio',
                                    required: false,
                                    id: 'sms',
                                },
                            ],
                        },
                    },
                    {
                        type: 'text',
                        caption: 'Email',
                        name: 'email',
                        id: 'email',
                        placeholder: 'Enter email address',
                        required: true,
                        keyboardFilter: 'email',
                        value: '',
                        validationMessages: [
                            {
                                type: 'emailService',
                                message: 'This email address is invalid. Please check and try again.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Email',
                        name: 'verifyEmail',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'text',
                        caption: 'Mobile Number',
                        name: 'mobileNumber',
                        id: 'mobileNumber',
                        placeholder: 'Enter mobile number',
                        required: true,
                        value: '',
                        keyboardFilter: 'pint',
                        maxLength: 10,
                        validationMessages: [
                            {
                                type: 'phoneService',
                                message: 'This phone number is invalid. Please double-check it.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Phone',
                        name: 'verifyPhone',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                ],
            };

            this.modalService.confirm(popup, undefined, insuredInformation).subscribe({
                next: (popupCallbackDetail: any) => {
                    if (popupCallbackDetail?.[0] === 'Send') {
                        const formData = popupCallbackDetail[1];

                        if (typeof formData === 'object' && formData.sendVia) {
                            this.policyData$.pipe(take(1)).subscribe((policyData) => {
                                if (!policyData || !policyData[this.policyNumber]) {
                                    this.toastService.add({
                                        type: 'error',
                                        title: 'Error',
                                        message: 'Policy data is not available.',
                                    });
                                    return;
                                }

                                const policySnapshot = policyData[this.policyNumber].policySnapshot;
                                const address =
                                    policySnapshot?.policyGeneralInformation?.propertyFullAddress?.value || '';
                                const zipcode = this.extractZipcode(address);

                                this.loadingService.showLoading();
                                this.portletService
                                    .getDocumentUploadLink({
                                        policyNumber: this.policyNumber,
                                        propertyZipCode: zipcode,
                                    })
                                    .subscribe({
                                        next: (documentUploadLink) => {
                                            this.loadingService.hideLoading();
                                            if (formData.sendVia === 'email') {
                                                this.sendDocumentUploadLinkByEmail(formData.email, documentUploadLink);
                                            } else if (formData.sendVia === 'sms') {
                                                this.phoneService
                                                    .sendDocumentUploadLinkSMS(
                                                        formData.mobileNumber,
                                                        this.policyNumber,
                                                        documentUploadLink
                                                    )
                                                    .subscribe({
                                                        next: () => {
                                                            this.toastService.add({
                                                                type: 'success',
                                                                title: 'Success',
                                                                message:
                                                                    'The document upload link was sent successfully',
                                                            });
                                                        },
                                                        error: (error) => {
                                                            console.error('SMS Error:', error);
                                                            this.toastService.add({
                                                                type: 'error',
                                                                title: 'Error',
                                                                message: "The document upload link couldn't be sent",
                                                            });
                                                        },
                                                    });
                                            }
                                        },
                                        error: (error) => {
                                            this.loadingService.hideLoading();
                                            console.error('Document upload session error:', error);
                                            this.toastService.add({
                                                type: 'error',
                                                title: 'Error',
                                                message: 'Unable to generate document upload link. Please try again.',
                                            });
                                        },
                                    });
                            });
                        }
                    }
                },
                error: () =>
                    this.toastService.add({
                        type: 'error',
                        title: 'Error',
                        message: 'Unable to open dialog. Please try again.',
                    }),
            });
        });
    }

    private sendDocumentUploadLinkByEmail(email: string, documentUploadLink: string): void {
        if (!this.emailService.validateEmailFormat(email)) {
            this.toastService.add({
                type: 'error',
                title: 'Invalid Email',
                message: 'Please enter a valid email address.',
            });
            return;
        }

        const emailRequest = this.emailService.buildDocumentUploadLinkEmailRequest(
            email,
            this.policyNumber,
            documentUploadLink
        );

        this.emailService.sendDocumentEmail(emailRequest as any).subscribe({
            next: () =>
                this.toastService.add({
                    type: 'success',
                    title: 'Success',
                    message: 'The document upload link was sent successfully via email.',
                }),
            error: () =>
                this.toastService.add({
                    type: 'error',
                    title: 'Error',
                    message: "The document upload link couldn't be sent.",
                }),
        });
    }
    sendSNLLink() {
        if (!this.policyNumber) {
            this.toastService.add({
                type: 'error',
                title: 'Error',
                message: 'No policy selected',
            });
            return;
        }

        this.policyData$.pipe(take(1)).subscribe((data) => {
            const insuredInformation =
                data?.[this.policyNumber]?.policySnapshot?.contactPreferences?.insuredInformation;

            const popup = {
                type: 'actionDialog',
                emailVerified: false,
                messageTitle: 'Send SNL Link',
                messageSubtitle: 'Select the channel through which the SNL link will be sent.',
                imageSrc: 'assets/images/send-document.svg',
                imageWidth: '120px',
                imageHeight: '120px',
                confirm: 'Send',
                cancel: 'Cancel',
                validationServices: {
                    emailService: this.emailService,
                    phoneService: this.phoneService,
                },
                fields: [
                    {
                        name: 'sendVia',
                        value: 'email',
                        caption: '',
                        type: 'radio',
                        required: true,
                        description: '',
                        options: {
                            optionsList: [
                                {
                                    name: 'sendVia',
                                    value: 'email',
                                    caption: '',
                                    description: 'Send via Email',
                                    type: 'radio',
                                    required: false,
                                    id: 'email',
                                },
                                {
                                    name: 'sendVia',
                                    value: 'sms',
                                    caption: '',
                                    description: 'Send via SMS',
                                    type: 'radio',
                                    required: false,
                                    id: 'sms',
                                },
                            ],
                        },
                    },
                    {
                        type: 'text',
                        caption: 'Email',
                        name: 'email',
                        id: 'email',
                        placeholder: 'Enter email address',
                        required: true,
                        keyboardFilter: 'email',
                        value: '',
                        validationMessages: [
                            {
                                type: 'emailService',
                                message: 'This email address is invalid. Please check and try again.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Email',
                        name: 'verifyEmail',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'email' },
                    },
                    {
                        type: 'text',
                        caption: 'Mobile Number',
                        name: 'mobileNumber',
                        id: 'mobileNumber',
                        placeholder: 'Enter mobile number',
                        required: true,
                        value: '',
                        keyboardFilter: 'pint',
                        maxLength: 10,
                        validationMessages: [
                            {
                                type: 'phoneService',
                                message: 'This phone number is invalid. Please double-check it.',
                            },
                        ],
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                    {
                        type: 'button',
                        caption: 'Verify Phone',
                        name: 'verifyPhone',
                        buttonType: 'borderless',
                        imageSrc: '',
                        showIf: { field: 'sendVia', value: 'sms' },
                    },
                ],
            };

            this.modalService.confirm(popup, undefined, insuredInformation).subscribe({
                next: (popupCallbackDetail: any) => {
                    if (popupCallbackDetail?.[0] === 'Send') {
                        const formData = popupCallbackDetail[1];

                        if (typeof formData === 'object' && formData.sendVia) {
                            this.policyData$.pipe(take(1)).subscribe((policyData) => {
                                if (!policyData || !policyData[this.policyNumber]) {
                                    this.toastService.add({
                                        type: 'error',
                                        title: 'Error',
                                        message: 'Policy data is not available.',
                                    });
                                    return;
                                }

                                const policySnapshot = policyData[this.policyNumber].policySnapshot;
                                const address =
                                    policySnapshot?.policyGeneralInformation?.propertyFullAddress?.value || '';
                                const zipcode = this.extractZipcode(address);

                                this.loadingService.showLoading();
                                this.portletService
                                    .getSNLLink({
                                        policyNumber: this.policyNumber,
                                        propertyZipCode: zipcode,
                                    })
                                    .subscribe({
                                        next: (snlLink) => {
                                            this.loadingService.hideLoading();
                                            if (formData.sendVia === 'email') {
                                                this.sendSNLLinkByEmail(formData.email, snlLink);
                                            } else if (formData.sendVia === 'sms') {
                                                this.phoneService
                                                    .sendSNLLinkSMS(formData.mobileNumber, this.policyNumber, snlLink)
                                                    .subscribe({
                                                        next: () => {
                                                            this.toastService.add({
                                                                type: 'success',
                                                                title: 'Success',
                                                                message: 'The SNL link was sent successfully',
                                                            });
                                                        },
                                                        error: (error) => {
                                                            console.error('SMS Error:', error);
                                                            this.toastService.add({
                                                                type: 'error',
                                                                title: 'Error',
                                                                message: "The SNL link couldn't be sent",
                                                            });
                                                        },
                                                    });
                                            }
                                        },
                                        error: (error) => {
                                            this.loadingService.hideLoading();
                                            console.error('SNL session error:', error);
                                            this.toastService.add({
                                                type: 'error',
                                                title: 'Error',
                                                message: 'Unable to generate SNL link. Please try again.',
                                            });
                                        },
                                    });
                            });
                        }
                    }
                },
                error: () =>
                    this.toastService.add({
                        type: 'error',
                        title: 'Error',
                        message: 'Unable to open dialog. Please try again.',
                    }),
            });
        });
    }

    private sendSNLLinkByEmail(email: string, snlLink: string): void {
        if (!this.emailService.validateEmailFormat(email)) {
            this.toastService.add({
                type: 'error',
                title: 'Invalid Email',
                message: 'Please enter a valid email address.',
            });
            return;
        }

        const emailRequest = this.emailService.buildSNLLinkEmailRequest(email, this.policyNumber, snlLink);

        this.emailService.sendDocumentEmail(emailRequest as any).subscribe({
            next: () =>
                this.toastService.add({
                    type: 'success',
                    title: 'Success',
                    message: 'The SNL link was sent successfully via email.',
                }),
            error: () =>
                this.toastService.add({
                    type: 'error',
                    title: 'Error',
                    message: "The SNL link couldn't be sent.",
                }),
        });
    }

    findMorePolicies(): void {
        const sessionId = this.route.snapshot.queryParams['sessionId'];
        this.router.navigate(['/third-party-login'], {
            queryParams: { sessionId: sessionId },
        });
    }

    onUserIconClick(): void {
        if (!this.isThirdParty) {
            this.showProfileNav = !this.showProfileNav;
            this.showNav = false;
            this.profileNavToggled.emit(this.showProfileNav);
        }
    }
}
